export default __webpack_public_path__ + "static/media/Elena_Sinelnikova_AHV_In_Moms_We_Trust.519d2664.jpg";